module.exports = __webpack_public_path__ + "static/media/group_sandbox.c06fb551.png";